import { getFileLink } from '@/shared/lib/get-document-link';
import { MobileTariffShpdSliceItem, MobileTariffSliceItem } from '@/store/slice/mobile-tariff.slice';
import { MobileTariffMappedOptions, MobileTariffShpdMappedOptions } from './helpers.types';

export const mobileSliceMapper = (data: MobileTariffMappedOptions): MobileTariffSliceItem => ({
  name: data.name,
  id: data.id,
  trpl_id: data.trpl_id,
  localized_name: data.localized_name,
  optionsMobile: data.optionsMobile,
  price: data.price,
  promotion_price: data.promotion_price,
  promotion_period: data.promotion_period,
  promotion_description: data.promotion_description,
  text: data.text,
  offer_file: getFileLink(data.offer_file),
  features: data.features,
});

export const mobileShpdSliceMapper = (data: MobileTariffShpdMappedOptions): MobileTariffShpdSliceItem => ({
  name: data.name,
  id: data.id,
  shpd_id_apartment: data.shpd_id_apartment,
  shpd_id_house: data.shpd_id_house,
  localized_name: data.localized_name,
  optionsMobile: data.optionsMobile,
  shpd_prices: data.shpd_prices,
  affects_shpd_promotion_ids: data.affects_shpd_promotions?.data.map(({ id }) => id),
  shpd_pdf: getFileLink(data.shpd_pdf),
  feautures_construktor: data.feautures_construktor,
});